import type { ZodTypeAny } from 'zod'
import { z } from 'zod'

import { steps } from '../source/steps'

// Function to convert fields to Zod schema
const createZodSchema = (
  fields: Array<{ field_name: string; required: boolean; type: string }>,
) => {
  const schema: Record<string, ZodTypeAny> = {}

  fields.forEach(field => {
    let zodField: ZodTypeAny

    // Determine the Zod type based on field type
    switch (field.type) {
      case 'input':
      case 'number':
      case 'select':
      case 'radio':
        zodField = z.string()
        break
      case 'date':
        zodField = z.any()
        break
      default:
        throw new Error(`Unsupported field type: ${field.type}`)
    }

    // Apply required or optional
    schema[field.field_name] = field.required ? zodField : zodField.optional()
  })

  return z.object(schema)
}

const fields: any[] = []

steps.forEach(step => {
  step.fields.forEach(field => {
    fields.push({
      field_name: field.field_name,
      required: field.required,
      type: field.type,
    })
  })
})

export const onboardingFormSchema = createZodSchema(fields)
